/**
 * Policy Navigator Page Component
 *
 * Main route component for the policy navigator application within the unified app.
 * Provides the chat interface for querying UK drone regulations.
 * Integrates with the unified authentication and routing system.
 *
 * Requirements: 1.4, 2.5, 7.3
 */

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthenticatedApiProvider } from './api/AuthenticatedApiContext';
import Chat from './pages/chat/Chat';
import NoPage from './pages/NoPage';

export interface PolicyNavigatorPageProps {}

/**
 * Policy Navigator Page - main route component for the unified app
 *
 * Provides the chat interface for querying UK drone regulations with
 * RAG-based responses and citation support. Integrates with the unified
 * authentication system and preserves all existing chat functionality.
 *
 * The component maintains its own internal routing for sub-pages while
 * working within the unified app's routing structure at /policy-navigator/*.
 */
export const PolicyNavigatorPage: React.FC<PolicyNavigatorPageProps> = () => {
  return (
    <AuthenticatedApiProvider>
      <Routes>
        {/* Main chat interface at /policy-navigator/ */}
        <Route path="/" element={<Chat />} />
        {/* Catch-all for unknown sub-routes */}
        <Route path="*" element={<NoPage />} />
      </Routes>
    </AuthenticatedApiProvider>
  );
};

export default PolicyNavigatorPage;
